export default "__VITE_ASSET__BXa$pRc___"